/**
 * @license ngx-css-variables
 * MIT license
 */

import { Directive, ElementRef, Injectable, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class CssVarsDirective {
    /**
     * @param {?} el
     */
    constructor(el) {
        this.el = el;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.cssVars)
            return;
        Object.keys(this.cssVars).forEach(key => {
            this.el.nativeElement.style.setProperty(key, this.cssVars[key]);
        });
    }
}
CssVarsDirective.ɵfac = function CssVarsDirective_Factory(t) { return new (t || CssVarsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CssVarsDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CssVarsDirective, selectors: [["", "css-vars", ""]], inputs: { cssVars: ["css-vars", "cssVars"] } });
/** @nocollapse */
CssVarsDirective.ctorParameters = () => [
    { type: ElementRef, },
];
CssVarsDirective.propDecorators = {
    "cssVars": [{ type: Input, args: ['css-vars',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CssVarsDirective, [{
        type: Directive,
        args: [{
                selector: '[css-vars]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { cssVars: [{
            type: Input,
            args: ['css-vars']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CssVarsService {
    constructor() {
        this.head = document.head || document.getElementsByTagName('head')[0];
    }
    /**
     * @param {?} vars
     * @return {?}
     */
    setVariables(vars) {
        const /** @type {?} */ style = document.createElement('style');
        style.type = 'text/css';
        const /** @type {?} */ styles = [];
        Object.keys(vars).forEach((property) => {
            styles.push(`${property}: ${vars[property]}`);
        });
        const /** @type {?} */ css = `:root {${styles.join('; ')}}`;
        style.appendChild(document.createTextNode(css));
        this.head.appendChild(style);
        return css;
    }
}
CssVarsService.ɵfac = function CssVarsService_Factory(t) { return new (t || CssVarsService)(); };
CssVarsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CssVarsService, factory: CssVarsService.ɵfac });
/** @nocollapse */
CssVarsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CssVarsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class CssVarsModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: CssVarsModule,
            providers: [CssVarsService]
        };
    }
    /**
     * @return {?}
     */
    static forChild() {
        return {
            ngModule: CssVarsModule,
            providers: [CssVarsService]
        };
    }
}
CssVarsModule.ɵfac = function CssVarsModule_Factory(t) { return new (t || CssVarsModule)(); };
CssVarsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CssVarsModule });
CssVarsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
/** @nocollapse */
CssVarsModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CssVarsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [CssVarsDirective],
                exports: [CssVarsDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CssVarsModule, { declarations: function () { return [CssVarsDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CssVarsDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { CssVarsModule, CssVarsDirective, CssVarsService };

